import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Player from '@vimeo/player';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
@Component({
  selector: 'app-admin-edit',
  templateUrl: './admin-edit.component.html',
  styleUrls: ['./admin-edit.component.scss']
})
export class AdminEditComponent implements OnInit {
  public player = null;
  Animals: boolean = false
  City: boolean = false
  DayVideo: boolean = false
  Interiors: boolean = false
  Water : boolean = false
  Nature: boolean = false
  Night: boolean = false
  Rain: boolean = false
  Snow: boolean = false
  isLoading: boolean = false
  success: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    public constants: ConstantsService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private dialogRef: MatDialogRef<AdminEditComponent>) { }
  titleEdit: UntypedFormGroup;
  ngOnInit(): void {
    this.load()
  }
  load() {
    this.Animals = this.data.Animals
    this.City = this.data.City
    this.DayVideo = this.data.DayVideo
    this.Interiors = this.data.Interiors
    this.Water = this.data.Water
    this.Nature = this.data.Nature
    this.Night = this.data.Night
    this.Rain = this.data.Rain
    this.Snow = this.data.Snow
    this.player = new Player('vimeo', {
      url: `https://player.vimeo.com/video/${this.data.url1}?h=${this.data.url2}`,
      responsive: true,
      autoplay: true,
      autopause: false,
      muted: 1,
      height: 400,
      controls: true,
      loop: false,
    });
    this.initialiaseTitleFrom()
  }
  onChangeTag(value) {
    if (value === 'Animals') {
      this.Animals = !this.Animals
    }
    else if (value === 'City') {
      this.City = !this.City
    }
    else if (value === 'DayVideo') {
      this.DayVideo = !this.DayVideo
    }
    else if (value === 'Interiors') {
      this.Interiors = !this.Interiors
    }
    else if (value === ' Water'){
      this.Water = !this.Water
    }
    else if (value === 'Nature') {
      this.Nature = !this.Nature
    }
    else if (value === 'Night') {
      this.Night = !this.Night
    }
    else if (value === 'Rain') {
      this.Rain = !this.Rain
    }
    else if (value === 'Snow') {
      this.Snow = !this.Snow
    }
  }
  initialiaseTitleFrom(): void {
    this.titleEdit = this.fb.group({
      author: new UntypedFormControl(this.data.author),
      cityLocation: new UntypedFormControl(this.data.cityLocation),
      Animals: new UntypedFormControl(this.data.Animals),
      Rain: new UntypedFormControl(this.data.Rain),
      Snow: new UntypedFormControl(this.data.Snow),
      City: new UntypedFormControl(this.data.City),
      Nature: new UntypedFormControl(this.data.Nature),
      Night: new UntypedFormControl(this.data.Night),
      Interiors: new UntypedFormControl(this.data.Interiors),
      DayVideo: new UntypedFormControl(this.data.DayVideo), 
      waterVideo : new UntypedFormControl(this.data.Water)
    })
  }
  async onSubmit(event: Event) {
    this.isLoading = true
    event.preventDefault
    const params = [
      { param: '{object}', value: 'videos' },
    ];
    const bodyObj = {
      Animals: this.titleEdit.value.Animals,
      City: this.titleEdit.value.City,
      DayVideo: this.titleEdit.value.DayVideo,
      Interiors: this.titleEdit.value.Interiors,
      Water : this.titleEdit.value.Water,
      Nature: this.titleEdit.value.Nature,
      Night: this.titleEdit.value.Night,
      Rain: this.titleEdit.value.Rain,
      Snow: this.titleEdit.value.Snow,
      author: this.titleEdit.value.author,
      cityLocation: this.titleEdit.value.cityLocation,
      videoId: this.data.videoId,
      campaignId: "window"
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.updateItem, params), JSON.stringify(bodyObj))
      .subscribe(data => {
        this.dialogRef.close(bodyObj)
        this.isLoading = false
        this.success = true
      }, error => {
        this.isLoading = false
      })
  }
}
